import React from "react";
import styles from "./App.module.css";
import LeftPanel from "./containers/LeftPanel/LeftPanel";
import Header from "./containers/Header";
import Histogram from "./containers/Histogram";
import ScatterPlot from "./containers/ScatterPlot";
import RightPanel from "./containers/RightPanel/RightPanel";
import ReactTooltip from "react-tooltip";
import InfoBox from "./containers/InfoBox";
import FullScreenToggle from "./containers/FullScreenToggle";
import Correlations from "./containers/Scores/Scores";
import DensityPlot from "./containers/DensityPlot";

function App() {
  return (
    <div className={styles.wrapper}>
      <Header />

      <main className={styles.main}>
        <LeftPanel />

        <ScatterPlot />

        <Histogram />

        <DensityPlot />

        <Correlations />

        <RightPanel />

        <ReactTooltip
          effect="solid"
          backgroundColor="grey"
          arrowColor="transparent"
        />

        <InfoBox />

        <FullScreenToggle />
      </main>
    </div>
  );
}

export default App;
